export default __webpack_public_path__ + "static/media/39t.864b9479.jpg";